const RELATIVE_TIME_DIVISIONS = [
  { amount: 60, unit: 'second' },
  { amount: 60, unit: 'minute' },
  { amount: 24, unit: 'hour' },
  { amount: 7, unit: 'day' },
  { amount: 4.34524, unit: 'week' },
  { amount: 12, unit: 'month' },
  { amount: Number.POSITIVE_INFINITY, unit: 'year' },
];

const RELATIVE_TIME_FORMATTER = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

/**
 * Formats a date string as human-friendly relative time (past or future).
 * Examples: "just now", "3 hours ago", "in 5 minutes".
 * @param {string | number | Date} dateInput
 * @returns {string}
 */
/**
 * Formats a date string as a short date (e.g., "Jan 12, 2026").
 * @param {string | number | Date} dateInput
 * @returns {string}
 */
export const formatDate = (dateInput) => {
  if (!dateInput) return '-';

  const target = new Date(dateInput);
  if (Number.isNaN(target.getTime())) {
    return 'Invalid date';
  }

  return target.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

export const formatRelativeTime = (dateInput) => {
  if (!dateInput) return '-';

  const target = new Date(dateInput);
  if (Number.isNaN(target.getTime())) {
    return 'Invalid date';
  }

  let duration = (target.getTime() - Date.now()) / 1000;
  for (const division of RELATIVE_TIME_DIVISIONS) {
    if (Math.abs(duration) < division.amount) {
      const rounded = Math.round(duration);
      if (division.unit === 'second' && Math.abs(rounded) < 10) {
        return 'just now';
      }
      return RELATIVE_TIME_FORMATTER.format(rounded, division.unit);
    }
    duration /= division.amount;
  }

  return '-';
};